import React from 'react';
import classNames from 'classnames';
import { Cell } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/Cell';
import { IGameCellProps } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/GameCell/type';
import { OverflowBubbleText } from '@/pages/dashboard/components/OverflowBubbleText';
import { getCountryFlag } from '@home/_config/countries';
import './index.scss';
import mobileGameDefaultIcon from '@/pages/dashboard/assets/svg/mobile-game-default.svg';
import { RANK_MEDALS } from '@/pages/dashboard/components/CommonTable/components/CommonTableCell/GameCell/constants';
import { navigate } from '@home/utils/utils';

export const GameCell = (props: IGameCellProps) => {
  const { className, style, record, config, getFilterItemText } = props;
  const {
    rankKey = 'rank',
    iconKey = 'icon',
    nameKey = 'name',
    countryCodeKey = 'countryCode',
    countryNameKey,
    linkKey,
    column,
    jumpType = 'window',
  } = config ?? {};

  const rank = record?.[rankKey] as number | undefined;
  const iconUrl = record?.[iconKey] as string | undefined;
  const gameName = record?.[nameKey] as string | undefined;
  const countryCode = record?.[countryCodeKey] as string | undefined;
  const linkUrl = linkKey ? (record?.[linkKey] as string | undefined) : undefined;

  const flagUrl = countryCode ? getCountryFlag(countryCode) : null;
  const countryDisplay = countryNameKey
    ? (record?.[countryNameKey] as string | undefined)
    : countryCode
      ? (getFilterItemText?.('country', String(countryCode), String(countryCode)) ?? String(countryCode))
      : null;

  const rankContent = rank !== null && rank !== undefined
    ? (RANK_MEDALS[rank] ? <img src={RANK_MEDALS[rank]} alt={`${rank}`} className="dbd-common-table__game-cell__rank-icon" /> : <span className="dbd-common-table__game-cell__rank-number">{rank}</span>)
    : null;

  const handleClick = () => {
    if (linkUrl) {
      navigate(linkUrl, {
        jumpType,
      });
    }
  };

  return (
    <Cell className={classNames('dbd-common-table__game-cell', className)} style={style} config={{ column }}>
      <span
        className={classNames('dbd-common-table__game-cell__inner', { 'dbd-common-table__game-cell__inner--link': !!linkUrl })}
        onClick={linkUrl ? handleClick : undefined}
      >
        {/* 排名 */}
        <span className="dbd-common-table__game-cell__rank">{rankContent}</span>

        {/* 游戏 icon */}
        {iconUrl ? (
          <img
            className="dbd-common-table__game-cell__icon"
            src={iconUrl}
            alt=""
            onError={(e) => {
              (e.currentTarget as HTMLImageElement).src = mobileGameDefaultIcon;
            }}
          />
        ) : (
          <img className="dbd-common-table__game-cell__icon" src={mobileGameDefaultIcon} alt="" />
        )}

        {/* 游戏名 + 国家 */}
        <span className="dbd-common-table__game-cell__info">
          <OverflowBubbleText text={gameName ?? '-'} className="dbd-common-table__game-cell__name" />
          {countryDisplay && (
            <span className="dbd-common-table__game-cell__country">
              {flagUrl && (
                <img className="dbd-common-table__game-cell__flag" src={flagUrl} alt="" />
              )}
              <OverflowBubbleText text={countryDisplay} className="dbd-common-table__game-cell__country-name" />
            </span>
          )}
        </span>
      </span>
    </Cell>
  );
};
